import React, { Component } from 'react';

import Dots from '../Dots/';

import './ReAnimation.scss'

import AppActions from '../../lib/flux/AppActions';

import * as data from '../../lib/data'

import { isMobile } from '../../lib/common.js'

import image_dot from '../../assets/dot-theme.svg';

import { TweenLite } from 'gsap';


let delay = 1400;
const list = ['imagine', 'flect', 'think', 'sist', 'spect', 'mix', 'form', 'bel', 'build', 'imagine']
const duration = .7;
const dots_end_x = -270;
const mobile_scale = .4;


class ReAnimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            step: 0,
            done: false
        }

    }

    static defaultProps = {
        done: () => {
            // console.log('all done, default props');
        }
    }
    componentDidMount() {

        const { intro, animation, dots } = this.props;

        if (intro) {
            return;
        }

        if (animation) {
            if (isMobile()) {
                TweenLite.set(this.refs.self, { scale: mobile_scale })
                //TweenLite.set(this.refs.self, { top: '25%' })
            }
            this.startAnimation();
            return;
        }

        this.setStatic();

    }

    onIntroComplete = () => {
        // console.log('BEN FADE IN BUTTONS AND PEOPLES');
        AppActions.animation({ intro: true }, () => {
            AppActions.header({ hidden: false });
            AppActions.modal({ stream: new Date().getTime() >= 1556380800000 && new Date().getTime() <= 1556409600000 });
        });
    }

    onDotAnimationComplete = () => {
        // console.log('REANIMATION', 'Complete')
        TweenLite.to(this.refs.dots, 1, { marginLeft: dots_end_x, ease: 'easeInOutExpo' })

        if (isMobile()) {
            TweenLite.to(this.refs.self, 1, { scale: mobile_scale, ease: 'easeInOutExpo' })
            TweenLite.to(this.refs.self, 1, { top: '140px', ease: 'easeInOutExpo', delay: 1 })
        }
        this.setStatic();

    }

    setStatic = () => {

        // TweenLite.set(this.refs.words,  {marginTop: -150 * 0})
        // TweenLite.set(this.refs.w1,     {opacity: 1})
        const { intro } = this.props;



        TweenLite.to(this.refs.words, 1, { marginTop: -150 * 0, ease: 'easeInOutExpo' })
        TweenLite.to(this.refs.w1, 1, { opacity: 1, ease: 'easeInOutExpo', delay: 1 })
        TweenLite.to(this.refs.re, 1, { opacity: 1, ease: 'easeInOutExpo', delay: 1, onComplete: this.onIntroComplete })

        if (!intro) {

            TweenLite.set(this.refs.dots, { marginLeft: dots_end_x, opacity: 0 })

            if (isMobile()) {
                TweenLite.set(this.refs.self, { scale: mobile_scale })
                TweenLite.set(this.refs.self, { top: '140px' })
            }

        }


        TweenLite.to(this.refs.dots, 1, { opacity: 1, ease: 'easeInOutExpo', delay: 1 })

    }
    startAnimation = () => {
        TweenLite.set(this.refs.dots, { marginLeft: dots_end_x })
        TweenLite.set(this.refs.w1, { opacity: 1 })
        TweenLite.set(this.refs.re, { opacity: 1 });
        this.animate();
    }


    renderWords = (speaker) => {
        return list.map((text, i) => {
            let ref = `w${i + 1}`
            return <div className="word" ref={ref}>{text}</div>
        })
    }
    animate = () => {

        const s_percent = this.state.step / 9; //ramp up speed

        let d = duration - (duration / 2 * s_percent)

        if (this.state.step < list.length) {
            TweenLite.to(this.refs.words, d, { marginTop: -150 * this.state.step, ease: 'easeInOutExpo' })
        }

        TweenLite.to(this.refs[`w${this.state.step + 1}`], d, { opacity: 1, ease: 'easeInOutExpo' })

        if (this.state.step > 0) {
            TweenLite.to(this.refs[`w${this.state.step}`], d, { opacity: 0, ease: 'easeInOutExpo' })
        }

        if (this.state.step < list.length - 1) {
            this.setState({ step: this.state.step + 1 });
            setTimeout(this.animate, 1000 - (500 * s_percent));
        } else {

            TweenLite.to(this.refs.words, duration, { marginTop: -150 * this.state.step, ease: 'easeInOutExpo', delay: 0 })
            TweenLite.to(this.refs.self, duration, { opacity: 0, ease: 'easeInOutExpo', delay: 2 })
            setTimeout(() => { this.props.done() }, 3000);

        }




    }

    render() {
        const { intro } = this.props;

        const { index, step, done, animation } = this.state;

        return (
            <div className={'Reanimation re-animation-container'} ref="self">

                {/* <div className={'dots-container'} ref="dots">
                    <div className="dot-anim" ref="dots_anim"></div>
                </div> */}

                <div className="dot-container" ref="dots">
                    <Dots animate={intro} onAnimationComplete={this.onDotAnimationComplete} />
                </div>

                <span className={'re'} ref="re">
                    re
                </span>

                {/* <span className={'re-animation-dot'}>
                    <img src={image_dot} />
                </span>
                 */}
                <div className="words">
                    <div className="word-container" ref="words">
                        {this.renderWords()}
                    </div>

                    {animation &&
                        <div className="gradient">
                            <div className="gradient-top"></div>
                            <div className="gradient-bottom"></div>
                        </div>

                    }

                </div>


            </div >
        );
    }
}

export default ReAnimation;

